export const first = (sentence: string): string => sentence.split(' ')[0];
